import { atom, RecoilState } from 'recoil';

export const fieldVerificationRefreshTrigger: RecoilState<number> =
  atom<number>({
    key: 'field-verification-refresh-trigger',
    default: 0,
  });
